export const CouldNotParse = 'CouldNotParse' as const
